var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navtop"},[_c('div',{staticClass:"group-left"},[_c('TitleBase',[_vm._v(_vm._s(_vm.sectionTitle))])],1),_c('div',{staticClass:"group_right"},[_c('UserInfo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }